<input NumbersOnly [allowDecimals]="true" maxlength="15" name="quantity" [(ngModel)]="display" (focus)="onFocus($event)"
    type="text" class="form-control">
